var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0H11.25V1.5375C7.45781 1.9125 4.5 5.10938 4.5 9V12.75C2.20781 16.875 0.95625 19.125 0.75 19.5H23.25C23.0438 19.125 21.7922 16.875 19.5 12.75V9C19.5 5.10938 16.5422 1.9125 12.75 1.5375V0ZM12 3C15.3141 3 18 5.68594 18 9V12.75C18 13.0031 18.0656 13.2563 18.1875 13.4766L20.7 18H3.3L5.8125 13.4766C5.93437 13.2516 6 13.0031 6 12.75V9C6 5.68594 8.68594 3 12 3ZM9.09375 21.75C9.42656 23.0438 10.6031 24 12 24C13.3969 24 14.5734 23.0438 14.9062 21.75H13.2984C13.0406 22.2 12.5531 22.5 12 22.5C11.4469 22.5 10.9594 22.2 10.7016 21.75H9.09375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellIcon);
export default __webpack_public_path__ + "static/media/notification-bell-icon.b9b715a4acac3c13fd895601fdd8eaa8.svg";
export { ForwardRef as ReactComponent };